module.exports = __webpack_public_path__ + "static/media/training3.c8aa58b4.png";